export const getHeadersAuth = () => {
  return {
    'Content-Type': 'application/json',
    Authorization: `%E8%9B%8B%E7%AD%92_%E6%9D%AF%E5%AD%90%20 ${localStorage.getItem('藍牙-冰淇淋')}`
  };
};
